__webpack_require__.p = "/pokemonapi/";